export enum Plane {
  X = 'X',
  Y = 'Y',
  Z = 'Z',
}
